import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient.ts';
import { FaShippingFast, FaClock, FaGift, FaPaw } from "react-icons/fa";
import NewArrivals from './NewArrivals .js';
import BreederAdoption from './breeder/BreederAdoption.js';
import AdoptionSlider from './adoptions/AdoptionSlider.js';
import AdoptionShop from './AdoptionShop.js';
import { Link } from 'react-router-dom';
import BestProducts from '../pages/BestProducts.js';
import PromoAnimalia from './PromoAnimalia.js';

const products = [
  { id: 1, name: "Brit Care Hypoallergénique", category: "Alimentation", subcategory: "Croquette", priceRange: "65,000DT – 269,000DT", image: "img/product/britcare.jpg" },
  { id: 2, name: "Brit Care Mini Sans Céréales", category: "Alimentation", subcategory: "Croquette", priceRange: "17,000DT – 69,000DT", image: "img/product/mini.png" },
  { id: 3, name: "Brit Fresh", category: "Alimentation", subcategory: "Croquette", priceRange: "45,000DT – 210,000DT", image: "img/product/fresh.png" },
  { id: 4, name: "Brit Premium by Nature", category: "Alimentation", subcategory: "Croquette", priceRange: "45,000DT – 220,000DT", image: "img/product/premium.png" },
  { id: 5, name: "BROKATON CHIEN", category: "Alimentation", subcategory: "Croquette", priceRange: "171,000DT – 242,000DT", image: "img/product/brokaton.jpg" },
  { id: 6, name: "COTAGRO CHIEN", category: "Alimentation", subcategory: "Croquette", priceRange: "198,000DT – 210,000DT", image: "img/product/cotagroadult.jpg" },
  { id: 7, name: "DOG VET SOLUTION", category: "Alimentation", subcategory: "Croquette", priceRange: "93,000DT – 395,000DT", image: "img/product/dogvet.png" },
  { id: 8, name: "Royal Canin Maxi", category: "Alimentation", subcategory: "Croquette", priceRange: "135,000DT – 355,000DT", image: "img/product/maxi.jpg" },
  { id: 9, name: "Royal Canin Medium", category: "Alimentation", subcategory: "Croquette", priceRange: "140,000DT – 355,000DT", image: "img/product/medium.jpg" },
  { id: 10, name: "Royal Canin Mini", category: "Alimentation", subcategory: "Croquette", priceRange: "95,000DT – 100,000DT", image: "img/product/miniiroyale.jpg" }
];

function Counter() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 680);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const [promoSlider, setPromoSlider] = useState(null);

  useEffect(() => {
    const fetchPromoSlider = async () => {
      const { data, error } = await supabase
        .from('promotion_slider')
        .select('*')
        .order('order_index', { ascending: true })
        .limit(1)
        .single();

      if (!error) setPromoSlider(data);
    };

    fetchPromoSlider();
  }, []);

  const getImageUrl = (path) =>
    `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${path}`;

  const style = {
    position: "absolute",
    bottom: isMobile ? "15px" : "20px",
    left: "50%",
    transform: isMobile ? "translateX(-50%)" : "translateX(-75%)",
    backgroundColor: "#ff69b4",
    color: "#fff",
    padding: isMobile ? "8px 16px" : "14px 24px",
    borderRadius: "25px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    textDecoration: "none",
    fontSize: isMobile ? "14px" : "16px",
  };

  const imgStyle = {
    width: isMobile ? "14px" : "18px",
    height: isMobile ? "14px" : "18px",
  };



  return (
    <>

      <NewArrivals />

      <br />
      <br />

      {/* <PromoAnimalia /> */}

      <AdoptionShop />
      {/* <br />
      <br /> */}



    </>

  );
}

export default Counter;
